import { Box, HStack, Text } from '@primerai/thread';
import styled from 'styled-components';
import { times } from '~/utils/object';

export type BarProps = {
  barColor: string;
  barHeight?: string;
  barWidth?: string;
};

type PasswordStrengthBarProps = {
  activeIndex: number;
  countBars?: number;
  passwordText?: string;
  barColor: string;
};

const DEFAULT_HEIGHT = '4px';
const DEFAULT_WIDTH = '80px';

const StyledBar = styled(Box)<{ width: string }>`
  ${({ width }): string => `
      width: calc(${width} - 4px);
  `}
`;

const Bar = ({
  barColor = '$grayScale.g3',
  barHeight = DEFAULT_HEIGHT,
  barWidth = DEFAULT_WIDTH,
}: BarProps) => (
  <StyledBar backgroundColor={barColor} height={barHeight} width={barWidth} />
);

const PasswordStrengthBar = ({
  barColor,
  activeIndex,
  passwordText,
  countBars = 4,
}: PasswordStrengthBarProps) => {
  const barWidth = `${100 / countBars}%`;

  return (
    <Box>
      <HStack gap="$2">
        {times(countBars).map((_, index) => {
          const componentId = `bar_${index}`;
          const currentColor =
            activeIndex >= index ? barColor : '$grayScale.g3';
          return (
            <Bar
              barColor={currentColor}
              barWidth={barWidth}
              key={componentId}
            />
          );
        })}
      </HStack>
      <Box mt="$2">
        <Text color="$grayScale.g5">{passwordText}</Text>
      </Box>
    </Box>
  );
};

export default PasswordStrengthBar;
